import { Paper } from '@mui/material'
import React from 'react'

export default function CardInfo({icon, title, text}) {
  return (
    <Paper elevation={3} style={{width: '160px', height: '70px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '8px', background: '#f9f9f9'}}>
      <div style={{width: '35%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <img src={icon} width={40} height={40} style={{color: '#fd7628'}} />
      </div>
      <div style={{width: '65%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
        <h2 style={{color: '#fd7628'}}>{title}</h2>
        <h3 style={{color: '#3D3D3D', fontSize: '16px', textAlign: 'center'}}>{text}</h3>
      </div>
    </Paper>
  )
}
